import { DistributorsOnBehalfGuestLogin } from 'legacy/hpscoutso/components/widgets/public/distributorsOnBehalf/DistributorsOnBehalfGuestLogin'
import React from 'react'

import { LayoutLogin as CoreLayoutLogin } from 'core/layout/Login'

import styles from './DistributorsOnBehalfLoginPage.module.scss'

export const DistributorsOnBehalfLoginPage = () => {
  return (
    <CoreLayoutLogin
      content={() => {
        return (
          <div className={styles.root}>
            <div className={styles.card}>
              <DistributorsOnBehalfGuestLogin />
            </div>
          </div>
        )
      }}
    />
  )
}
